import { isIE9, isIP } from './util'
export const getEnv = () => {
    let host = location.host;
    // 开发环境
    if (host.indexOf('localhost') > -1 || host.indexOf('192') > -1) {
        return 'dev-'
    }
    let pre = location.host.match(/^.*-/);
    // 正式环境
    if (pre === null) {
        return '';
    }
    // 测试及预发布环境
    return pre[0];
}

export function loginPage() {
    const host = window.location.host;
    const hostToUrl = {
        'pangu.songshuai.com': 'https://oa.songshuai.com',
        'pangu-pre.songshuai.com': 'https://oa-pre.songshuai.com'
    };
    // 默认使用测试环境 URL（匹配所有其他 host）
    let pageUrl = hostToUrl[host] || 'https://oa-test.songshuai.com';

    // 从 localStorage 获取状态（注意：localStorage 存储的是字符串）
    const loginPageStatus = localStorage.getItem('loginPageStatus');
    // 严格判断状态是否为 '1'（避免类型转换问题）
    if (loginPageStatus !== '1') {
        pageUrl = '/login'; // 传统登录页
    }
    return pageUrl;
}

export const getBaseUrl = () => {
    let host = location.host, hostname = location.hostname;
    if (host.indexOf('localhost') > -1 || isIP(hostname)) {
        if(localStorage.getItem('IP')) {
            return '//' + localStorage.getItem('IP') + '/pangu/'
        }
        return 'http://pangu.zc.dev.myyixue.com/pangu/'
//        return 'http://127.0.0.1:8080/'
        // return '//192.168.31.105:8080/'    // 欧阳，营销会
        // return '//192.168.31.85:8080/'   // 雪飞，外呼
        // return '//192.168.31.157:8080/'   // 聪聪，线索
        // return '//192.168.30.254:8080/'   // 张宇
    } else if (host.indexOf('pangu-test.songshuai.com') > -1) {
        return '//api-pangu-test.songshuai.com/pangu/'
    } else if (host.indexOf('pangu.fe.dev.myyixue.com') > -1) {
        return '//pangu.zc.dev.myyixue.com/pangu/' // 开发环境接口域名
    }
    return `//api-${hostname}/pangu`
}




export const uploadPicture = () => {
    let host = location.host,hostname=location.hostname;
    // sop开发环境
    if (host.indexOf('localhost') > -1 || isIP(hostname)) {
        if(localStorage.getItem('IP')) {
            return '//' + localStorage.getItem('IP') + '/api/'
        }
        return 'http://test001-gw.myyixue.com/sales-tool/api/'
        //return '//localhost:51108/'
    } else if (host.indexOf('pangu-test.songshuai.com') > -1) {
        return 'http://test001-gw.myyixue.com/sales-tool/api/'
    }
    return `//fuxi.songshuai.com/sales-tool/api/`
}
export const getHostName = () => {
    let host = location.host,hostname=location.hostname;
    // 开发环境
    if (host.indexOf('localhost') > -1 || isIP(hostname)) {
        if(localStorage.getItem('IP')) {
            return '//' + localStorage.getItem('IP') + '/api/'
        }
        return '//api-pangu-test.songshuai.com'
    } else if (host.indexOf('pangu-test.songshuai.com') > -1) {
        return '//api-pangu-test.songshuai.com'
    }
    return `${hostname}`

}
export const setWindowNID = (menu, path) => {
    for (var i in menu) {
        if (menu[i].Url == path) {
            window.nid = menu[i].ParentPath[0]
        }
        if (menu[i].ChildNavigations) {
            setWindowNID(menu[i].ChildNavigations, path);
        }
    }
}

export const toUrl = () => {
    let host = location.host,hostname=location.hostname;
    // host = 'pangu.songshuai.com'
    // hostname = 'pangu.songshuai.com'
    // 开发环境
    if (host.indexOf('localhost') > -1 || isIP(hostname)) {
        if(localStorage.getItem('IP')) {
            return '//' + localStorage.getItem('IP') + '/api/'
        }
        return 'http://cs-pangu.myyixue.com'
    } else if (host.indexOf('pangu-test.songshuai.com') > -1) {
        return 'http://cs-pangu.myyixue.com'
    }
    return `https://cs-${hostname}/`
}
